export const filterByOwner = (resources, id) => {
  if (!resources) return null;
  return resources.filter((r) => r.owner === id);
};
export const findByOwner = (resources, id) => {
  if (!resources) return null;
  return resources.find((r) => r.owner === id);
};
export const findById = (resources, id) => {
  if (!resources) return null;
  return resources.find((r) => r.id === id);
};
